/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint no-param-reassign: 0 */

// Por bluetooth viaja la CLAVE de la clase (AIclasses[i][1]), no la etiqueta
// del bloque (AIclasses[i][0]). "GET_CLASS" pide al modelo la siguiente
// clasificación; sin él deja de enviar.

const SERIAL_SETUP = `
#include <SoftwareSerial.h>
SoftwareSerial BT1(9,8); // RX, TX recordar que se cruzan
char command;
`;

export const AI_bluethooth_control = (block, generator) => {
  const clases = block.AIclasses || [];
  const ramas = clases.map((_, i) => generator.statementToCode(block, `BUTN${i}`));

  // Clave fija: el legacy la armaba con valueToCode sobre un dummy input, que
  // siempre resolvía a '', y así la emite prod.
  generator.definitions_.declare_var_define_buttons = SERIAL_SETUP;

  const parser = ramas
    .map((rama, i) => ` if (command == "${clases[i][1]}") {
    ${rama}
  ${(i === ramas.length - 1) ? '}' : '} else'}`)
    .join('');

  generator.definitions_.AI_bluethooth_control = `
String buffer = "";

void commandParser_ai(String command) {
 ${parser}
}
`;

  generator.setups_.setup_buttons_ = 'BT1.begin(9600);\n';

  return `
if (BT1.available()) {
  command = BT1.read();
  if (command == '\\n') {
    commandParser_ai(buffer);
    buffer = "";
    BT1.println("GET_CLASS");
  } else {
    buffer += command;
  }
}
`;
};
